module.exports = __webpack_public_path__ + "static/media/main_slide_220215.87aceb62.jpg";